import styled, { x } from '@xstyled/styled-components';
import React from 'react';
import DownloadIcon from '~/assets/icons/download-policy.svg';
import { select } from '~/lib/select';
import { Flex } from '~/ui/flex/Flex';
import { TrainingState, useTrainingStore } from '../state';
import { useDocumentsStore } from './Store';
import { Button } from '~/ui/buttons';
import { t } from 'ttag';

const List = styled.ulBox`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 350px;
  overflow-y: auto;

  @media (max-height: 550px) {
    max-height: 150px;
  }
`;

const ListItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 300px;
  padding: 15px 0px;
  background-color: transparent;
  border: 2px solid transparent;
  border-bottom: 2px solid ${({ theme }) => theme.colors.greyLight};

  p {
    max-width: 250px;
  }

  &:hover {
    border-bottom: 2px solid ${({ theme }) => theme.colors.accentDark};
  }

  &:focus {
    border: 2px solid ${({ theme }) => theme.colors.blueMed};
  }

  @media (max-width: sm) {
    width: 100%;
  }
`;

const selector = (s: TrainingState) => select(s, 'policies');

export const Root = () => {
  const { policies } = useTrainingStore(selector);

  const { toggle } = useDocumentsStore();

  const handleFocus = (event: React.FocusEvent<HTMLElement>) => {
    if (!event.currentTarget.contains(event.relatedTarget as Node)) {
      event.currentTarget.focus();
    }
  };

  return (
    <>
      <Flex
        w={{ _: '80vw', sm: 'auto' }}
        gap="30px"
        variant="list"
        className="modalStyleForDarkTheme"
        autoFocus={true}
        tabIndex={1000}
        onBlur={handleFocus}
        onFocus={handleFocus}
      >
        <x.h4
          textAlign="center"
          fontSize={{ _: 'lg', sm: 'xl' }}
        >{t`Documents`}</x.h4>
        <List>
          {policies?.map((policy, i) => (
            <ListItem
              target="_blank"
              href={policy.policyUrl}
              key={policy.id}
              tabIndex={1002 + i}
            >
              <x.p textAlign="left">{policy.name}</x.p>
              <x.div aria-hidden="true">
                <DownloadIcon />
              </x.div>
            </ListItem>
          ))}
        </List>
        <Button
          onClick={() => toggle(false)}
          backgroundColor="greyLight"
          color="black"
          fontWeight={700}
          id="closeBtnForDocument"
          autoFocus={true}
          tabIndex={10010}
        >
          {t`Close`}
        </Button>
      </Flex>
    </>
  );
};
